import { render, staticRenderFns } from "./PostApprove.vue?vue&type=template&id=bd1fe51c&scoped=true"
import script from "./PostApprove.vue?vue&type=script&lang=js"
export * from "./PostApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1fe51c",
  null
  
)

export default component.exports